if (!customElements.get("td-modal")) {
    class TDModal extends HTMLElement {
        constructor() {
            super();
            this.MODAL_CLOSE_CLASS = '.materialModal__closer';
            this.CONTAINER_CLASS = '.materialModal'

            this.modalCloseButton = this.querySelector(this.MODAL_CLOSE_CLASS);
            this.modalContainer = this.querySelector(this.CONTAINER_CLASS);
        }
    
        connectedCallback() {
            this.modalCloseButton.addEventListener('click', () => {
                this.closeModal()
            })
        }

        closeModal() {
            if (!this.modalContainer.classList.contains('.materialModal__hide')) {
                this.modalContainer.classList.add('materialModal__hide')
            }
        }

        openModal() {

        }
    }

    customElements.define("td-modal", TDModal);
}